import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { env } from "../config/BaseConfig";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (env !== "production") return;
    // Google Analytics 測定 ID を入力して設定
    ReactGA.initialize("G-DSDMM4BM02");
    ReactGA.send({
      hitType: "pageview",
      // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
      page: location.pathname + location.search,
    });
  }, [location]);
};

export default usePageTracking;
